import { render, staticRenderFns } from "./add-patient.vue?vue&type=template&id=53ea4ddd&"
import script from "./add-patient.vue?vue&type=script&lang=js&"
export * from "./add-patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports